import { Flex, NavLink, Tabs as MantineTabs } from '@mantine/core'

import type { TabsProps } from '@/components/Tabs/Tabs.types'

import classes from './Tabs.module.css'

export function Tabs({ activeFilter, activeTab, filters, tabs }: TabsProps) {
  return (
    <MantineTabs value={activeTab}>
      <MantineTabs.List className={classes.tabs}>
        <Flex className={classes.tabsBackground}>
          {tabs.map(tab => (
            <MantineTabs.Tab
              key={tab.id}
              className={classes.tab}
              onClick={tab.onClick}
              value={tab.id}
            >
              {tab.label.toUpperCase()}
            </MantineTabs.Tab>
          ))}
        </Flex>

        {filters && (
          <Flex className={classes.tabFilters}>
            {filters.map(filter => (
              <NavLink
                key={filter.label}
                active={activeFilter === filter.value}
                className={classes.tabFilter}
                label={filter.label}
                onClick={filter.onClick}
              />
            ))}
          </Flex>
        )}
      </MantineTabs.List>

      {tabs.map(tab => (
        <MantineTabs.Panel key={tab.id} mt={22} value={tab.id}>
          {tab.children}
        </MantineTabs.Panel>
      ))}
    </MantineTabs>
  )
}
